import { gql } from "@apollo/client";

const getUserCompanyIdLocal = gql`
  query GetUserCompanyIdLocal {
    userCompanyId @client
  }
`;

export default getUserCompanyIdLocal;
